import { Typography, Paper, Box } from '@mui/material';

const Home = () => {
  return (
    <Box sx={{ maxWidth: 800, margin: '0 auto' }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
        Home
      </Typography>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="body1" paragraph>
          The provided documents outline Sound Transit’s strategic initiatives for regional expansion and community development through 2025. One primary focus is a billion-dollar design services framework that awards contracts to 18 diverse consulting firms to streamline engineering and architectural projects over a potential seven-year period.
        </Typography>
        <Typography variant="body1" paragraph>
          This contracting model aims to reduce administrative costs and enhance project schedules while fulfilling equity goals by involving small and local businesses. Additionally, the sources highlight the transit-oriented development program, which repurposes surplus construction land into affordable housing and mixed-use spaces.
        </Typography>
        <Typography variant="body1" paragraph>
          Recent milestones include the groundbreaking of residential projects in Bellevue and the continued integration of housing near transit hubs to boost ridership. Together, these efforts represent a coordinated approach to infrastructure delivery and the creation of vibrant, transit-adjacent communities.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Home;
